import { Box } from "@mui/material";
import { Radius } from "Infrastructure/Themes/Themes";

const SIZE = 16;

export const Dot = () => <Box flexShrink={0} width={SIZE} height={SIZE} borderRadius={Radius.MAX} bgcolor="primary.main" />;
